import * as PropTypes from 'prop-types';
import * as React from 'react';
import UserCurrency from '../../shared/user_currency';
import PriceRange from '../../dashboard/selling/shared/price_range';

class PriceFilter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      price_min: this.props.priceMin || '',
      price_max: this.props.priceMax || '',
    };

    this.formSubmitted = this.formSubmitted.bind(this);
    this.onChange = this.onChange.bind(this);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      price_min: nextProps.priceMin,
      price_max: nextProps.priceMax,
    });
  }

  onChange(event) {
    const newState = {};
    newState[event.target.name] = event.target.value;

    this.setState(newState);
  }

  formSubmitted(e) {
    e.preventDefault();
    this.props.priceChanged({
      priceMin: this.state.price_min,
      priceMax: this.state.price_max,
    });
  }

  render() {
    return (
      <PriceRange
        price_min={this.state.price_min}
        price_max={this.state.price_max}
        onChange={this.onChange}
        onClick={this.formSubmitted}
        currency={UserCurrency.currency}
      />
    );
  }
}

PriceFilter.propTypes = {
  priceChanged: PropTypes.func.isRequired,
  priceMin: PropTypes.string,
  priceMax: PropTypes.string,
};

export default PriceFilter;



// WEBPACK FOOTER //
// ./javascripts/components/digital_listings/index_page/price_filter.jsx